import { Routes } from "@angular/router"
import { authGuard, loginGuard } from "../guards/auth.guard"
import { LayoutEmpty } from "../components/layouts/layout-empty/main/main"
import { LayoutSidebar } from "../components/layouts/layout-sidebar/main/main"

export const pages: Routes = [
	{ path: "", redirectTo: "login", pathMatch: "full" },
	{
		path: "",
		component: LayoutEmpty,
		children: [
			{
				path: "login",
				loadComponent: () => import("./login/login").then(m => m.Login),
				canActivate: [loginGuard]
			},
			{ path: "logout", loadComponent: () => import("./logout/logout").then(m => m.Logout) }
		]
	},
	{
		path: "",
		component: LayoutSidebar,
		children: [
			{
				path: "workgroups",
				children: [
					{
						path: "",
						loadComponent: () =>
							import("./workgroups/workgroups-list/workgroups-list").then(m => m.PageWorkgroupsList),
						canActivate: [authGuard(["ADMINISTRATOR", "PRICING_MANAGER", "APPROVER"])]
					},
					{
						path: "create",
						loadComponent: () =>
							import("./workgroups/workgroup-create/workgroup-create").then(m => m.PageWorkgroupCreate),
						canActivate: [authGuard(["ADMINISTRATOR"])]
					},
					{
						path: ":id",
						loadComponent: () =>
							import("./workgroups/workgroup-detail/workgroup-detail").then(m => m.PageWorkgroupDetail),
						canActivate: [authGuard(["ADMINISTRATOR"])]
					}
				]
			},
			{
				path: "users",
				children: [
					{
						path: "",
						loadComponent: () => import("./users/users-list/users-list").then(m => m.PageUsersList),
						canActivate: [authGuard(["ADMINISTRATOR"])]
					},
					{
						path: ":sub",
						loadComponent: () => import("./users/user-detail/user-detail").then(m => m.PageUserDetail),
						canActivate: [authGuard(["ADMINISTRATOR"])]
					}
				]
			},
			{
				path: "pdr",
				children: [
					{
						path: "",
						loadComponent: () => import("./pdr/pdr-list/pdr-list").then(m => m.PagePdrList),
						canActivate: [authGuard(["ADMINISTRATOR", "PRICING_MANAGER"])]
					},
					{
						path: "create",
						loadComponent: () => import("./pdr/pdr-create/pdr-create").then(m => m.PagePdrCreate),
						canActivate: [authGuard(["ADMINISTRATOR", "PRICING_MANAGER"])]
					},
					{
						path: ":id",
						loadComponent: () => import("./pdr/pdr-detail/pdr-detail").then(m => m.PagePdrDetail),
						canActivate: [authGuard(["ADMINISTRATOR", "PRICING_MANAGER"])]
					}
				]
			},
			{
				path: "pdr-clusters",
				children: [
					{
						path: "",
						loadComponent: () => import("./pdr/pdr-clusters/pdr-clusters").then(m => m.PagePdrClusters),
						canActivate: [authGuard(["ADMINISTRATOR", "PRICING_MANAGER"])]
					},
					{
						path: "create",
						loadComponent: () =>
							import("./pdr/pdr-cluster-create/pdr-cluster-create").then(m => m.PagePdrClusterCreate),
						canActivate: [authGuard(["ADMINISTRATOR", "PRICING_MANAGER"])]
					},
					{
						path: ":id",
						loadComponent: () =>
							import("./pdr/pdr-cluster-detail/pdr-cluster-detail").then(m => m.PagePdrClusterDetail),
						canActivate: [authGuard(["ADMINISTRATOR", "PRICING_MANAGER"])]
					}
				]
			},
			{
				path: "tariffs",
				children: [
					{
						path: "",
						loadComponent: () => import("./tariffs/tariffs-list/tariffs-list").then(m => m.PageTariffsList),
						canActivate: [authGuard(["ADMINISTRATOR", "PRICING_MANAGER", "APPROVER"])]
					},
					{
						path: "create",
						loadComponent: () =>
							import("./tariffs/tariff-create/tariff-create").then(m => m.PageTariffCreate),
						canActivate: [authGuard(["ADMINISTRATOR", "PRICING_MANAGER"])]
					},
					{
						path: ":id",
						loadComponent: () =>
							import("./tariffs/tariff-detail/tariff-detail").then(m => m.PageTariffDetail),
						canActivate: [authGuard(["ADMINISTRATOR", "PRICING_MANAGER", "APPROVER"])]
					}
				]
			},
			{
				path: "emsp",
				children: [
					{
						path: "",
						loadComponent: () => import("./emsp/emsp-list/emsp-list").then(m => m.PageEmspList),
						canActivate: [authGuard(["ADMINISTRATOR", "PRICING_MANAGER"])]
					},
					{
						path: "create",
						loadComponent: () => import("./emsp/emsp-create/emsp-create").then(m => m.PageEmspCreate),
						canActivate: [authGuard(["ADMINISTRATOR", "PRICING_MANAGER"])]
					},
					{
						path: ":id",
						loadComponent: () => import("./emsp/emsp-detail/emsp-detail").then(m => m.PageEmspDetail),
						canActivate: [authGuard(["ADMINISTRATOR", "PRICING_MANAGER"])]
					}
				]
			},
			{
				path: "emsp-groups",
				children: [
					{
						path: "",
						loadComponent: () => import("./emsp/emsp-groups/emsp-groups").then(m => m.PageEmspGroups),
						canActivate: [authGuard(["ADMINISTRATOR", "PRICING_MANAGER"])]
					},
					{
						path: "create",
						loadComponent: () =>
							import("./emsp/emsp-group-create/emsp-group-create").then(m => m.PageEmspGroupCreate),
						canActivate: [authGuard(["ADMINISTRATOR", "PRICING_MANAGER"])]
					},
					{
						path: ":id",
						loadComponent: () =>
							import("./emsp/emsp-group-detail/emsp-group-detail").then(m => m.PageEmspGroupDetail),
						canActivate: [authGuard(["ADMINISTRATOR", "PRICING_MANAGER"])]
					}
				]
			},
			{
				path: "simulator",
				loadComponent: () => import("./simulator/simulator").then(m => m.PageSimulator),
				canActivate: [authGuard(["ADMINISTRATOR", "PRICING_MANAGER", "APPROVER"])]
			}
		]
	},
	{ path: "**", redirectTo: "/" }
]
